// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductCompareCarouselStyles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import Close from "@tps/XDL/Icons/Close";
import { css } from "styled-components";

ProductCompareCarouselStyles.removeProductFromCompareButtonIcon = {
    src: Close,
    size: 8,
}

ProductCompareCarouselStyles.navigationLinkGridItem = {
    width: 12,
    css: css`
        padding-top: 30px;
    `
}

ProductCompareCarouselStyles.headerTextGridItem = {
    css: css`
        max-width: unset;
        flex-basis: unset;
    `,
};

ProductCompareCarouselStyles.headerContainer = {
    gap: 5,
    offsetCss: css`
        justify-content: space-between;
    `
};

ProductCompareCarouselStyles.headerButtonsGridItem = {
    css: css`
        justify-content: flex-end;
        max-width: unset;
        flex-basis: unset;
    `,
};